import type { Project } from '../../data/projects';

export interface ProjectNavigation {
  home: { path: string; label: string };
  basePath: string;
  termsPath?: string;
}

export function projectNavigation(
  project: Pick<Project, 'name' | 'slug'>,
  navigation?: ProjectNavigation,
): ProjectNavigation {
  return navigation ?? {
    home: { path: `/projects/${project.slug}`, label: project.name },
    basePath: `/projects/${project.slug}`,
  };
}
